export default [
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/*webpackChunkName: "Login" */ '@/views/login/Login.vue'),
    meta: {
      title: 'Login',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
    beforeEnter: (to, from, next) => {
      if (to.query.redirect) {
        if (
          to.query.redirect.includes('logout') ||
          to.query.redirect.includes('login') ||
          to.query.redirect == '/'
        ) {
          next({
            name: 'Login',
          })
        } else {
          next()
        }
      } else {
        next()
      }
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () =>
      import(/*webpackChunkName: "Logout" */ '@/views/logout/Logout.vue'),
    meta: {
      title: 'Logout',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
    beforeEnter: (to, from, next) => {
      if (to.query.redirect) {
        if (
          to.query.redirect.includes('logout') ||
          to.query.redirect.includes('login') ||
          to.query.redirect == '/'
        ) {
          next({
            name: 'Logout',
          })
        } else {
          next()
        }
      } else {
        next()
      }
    },
  },
  {
    path: '/auth/callback',
    name: 'OidcCallback',
    component: () =>
      import(
        /*webpackChunkName: "OidcCallback" */ '@/views/auth/OidcCallback.vue'
      ),
    meta: {
      title: 'Login',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
    beforeEnter: (to, from, next) => {
      if (to.query.redirect) {
        if (
          to.query.redirect.includes('logout') ||
          to.query.redirect.includes('login') ||
          to.query.redirect == '/'
        ) {
          next({
            name: 'Logout',
          })
        } else {
          next()
        }
      } else {
        next()
      }
    },
  },
  {
    path: '/sso',
    name: 'SsoLogin',
    component: () =>
      import(/*webpackChunkName: "SsoLogin" */ '@/views/auth/SsoLogin.vue'),
    meta: {
      title: 'SSO Login',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () =>
      import(
        /*webpackChunkName: "ResetPassword" */ '@/views/resetPassword/ResetPassword.vue'
      ),
    meta: {
      title: 'Reset Password',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () =>
      import(
        /*webpackChunkName: "ForgotPassword" */ '@/views/forgotPassword/ForgotPassword.vue'
      ),
    meta: {
      title: 'Forgot Password',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: () =>
      import(
        /*webpackChunkName: "SignUpContainer" */ '@/views/signUp/SignUpContainer.vue'
      ),
    meta: {
      title: 'Sign Up',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
  },
  {
    path: '/no-access',
    name: 'NoAccess',
    component: () =>
      import(/*webpackChunkName: "NoAccess" */ '@/views/noAccess/NoAccess.vue'),
    meta: {
      title: 'No Access',
      allowAnonymous: true,
      showHeader: false,
      showFooter: true,
    },
  },
  {
    path: '/outage',
    name: 'Outage',
    component: () =>
      import(/*webpackChunkName: "Outage" */ '@/views/outage/Outage.vue'),
    meta: {
      title: 'Outage',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () =>
      import(
        /*webpackChunkName: "TermsOfUse" */ '@/views/terms/TermsOfUse.vue'
      ),
    meta: {
      title: 'Terms of Use',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
  },
  {
    path: '/vigil-cloud-privacy-policy',
    name: 'PrivacyPolicy',
    component: () =>
      import(
        /*webpackChunkName: "PrivacyPolicy" */ '@/views/terms/PrivacyPolicy.vue'
      ),
    meta: {
      title: 'Privacy Policy',
      allowAnonymous: true,
      showHeader: false,
      showFooter: false,
    },
  },
]
